import { createContext } from "react"
import { DefaultDoctorInterface, DoctorInterface } from "../../doctors/types"

export interface PaymentInterface {
  _id: string,
  doctor: DoctorInterface,
  amount: number,
  subscriptionYear: string,
  type: string,
  note: string,
  createdAt: string,
  updatedAt: string,
}

export const DefaultPaymentInterface:PaymentInterface = {
  _id: "",
  doctor: DefaultDoctorInterface,
  amount: 0,
  subscriptionYear: "",
  type: "",
  note: "",
  createdAt: "",
  updatedAt: "",
}


export interface ShowPaymentInterface {
  showSuccessMsg: boolean, setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddPaymentModal: boolean, setShowAddPaymentModal: (showAddPaymentModal: boolean) => void,
  showDeletePaymentModal: boolean, setShowDeletePaymentModal: (showDeletePaymentModal: boolean) => void,
  selectedPayment: PaymentInterface, setSelectedPayment: (selectedPayment: PaymentInterface) => void,
  subscriptionYear: string, setSubscriptionYear: (subscriptionYear: string) => void,
  note: string, setNote: (note: string) => void,
  statusType: string, setStatusType: (statusType: string) => void,
} 

export const DefaultShowPaymentInterface:ShowPaymentInterface =  {
  showSuccessMsg: false, setShowSuccessMsg: () => {},
  showAddPaymentModal: false, setShowAddPaymentModal: () => {},
  showDeletePaymentModal: false, setShowDeletePaymentModal: () => {},
  selectedPayment: DefaultPaymentInterface, setSelectedPayment: () => {},
  subscriptionYear: "", setSubscriptionYear: () => {},
  note: "", setNote: () => {},
  statusType: "", setStatusType: () => {},
} 

export const ShowPaymentContext = createContext<ShowPaymentInterface>(DefaultShowPaymentInterface)


export const WorkYears = [
  // "2013",
  // "2014",
  // "2015",
  // "2016",
  // "2017",
  // "2018",
  // "2019",
  
  // "2020",
  // "2021",
  // "2022",
  "2023",
  "2024",
  "2025",
  "2026",
]


export enum statusTypePayment  {
  isDoctorSubscribedForYear = "isDoctorSubscribedForYear"
} 